import { files } from "@/firebase.js";
import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false
  },
  mutations: {
    setList(state, devices) {
      state.list = devices;
    },
    setListLoading(state, loading) {
      state.listLoading = loading;
    }
  },
  actions: {
    async loadAll({ commit }, payload) {
      commit("setListLoading", true);
      let response = await api.get("devices/events", {
        params: {
          limit: payload.limit,
          ids: payload.ids
        }
      });
      commit("setList", response.data);
      commit("setListLoading", false);
    }
  },
  getters: {
    listLoading(state) {
      return state.listLoading;
    },
    list(state) {
      return state.list;
    }
  }
};
